import type { ReasonCodes } from "../../types/operations/osad.type";

export const mockReasonCodes = {
  default: [
    {
      id: 79,
      name: "All Short",
    },
    {
      id: 80,
      name: "Other",
    },
  ],
} as const satisfies Record<string, ReasonCodes[]>;
